<template>
<div :data-key="name">
	<button v-if="actions" v-for="action in actions"
	type="button"
	class="btn btn-sm btn-secondary cell-action"
	:title="action.description"
	@click="action.action"
	v-html="action.name">
	</button>

	<template v-if="isArray">
		<jm-cell v-for="(entry, index) in value"
		:content="content"
		:entity="entity"
		:view="view"
		:index="index"
		:key="key(index)"></jm-cell>
	</template>

	<div v-else v-bind:is="widget" v-bind="attr"></div>
</div>
</template>

<script>
import moment from 'moment'
import { Entity } from '@/assets/js/JMan/Entity'
import jman from '@/services/jman'
import { ModelTableView } from '@/assets/js/ModelView'
import * as ViewWidgets from './ItemViewWidgets'

const tsrx = /^[0-9]{4}-[0-9]{2}-[0-9]{2}([T ][0-9]{2}(:[0-9]{2}(:[0-9]{2}(.[0-9]*)?)?)?)?/;
const uuidrx = /^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$/;

export default {
	name: "JmCell",

	props: {
		content: [Number, String, Object, Array],
		entity: Object,
		index: Number,
		view: { type: Object, default: () => { return {} } },
	},

	computed: {

		attr () {
			let attr = {
				entity: this.entity,
				name: this.view.name,
				content: this.entity && this.view.value instanceof Function ?
					this.view.value(this.entity, this.index) :
					this.content
			};

			if (attr.content instanceof Object &&
				!(attr.content instanceof Entity) &&
				attr.content.data) {
				// See if we can convert it into a non-generic Entity
				const entity = Entity.make(attr.content);
				attr.content = entity;
			}

			if (this.view.type == 'url') {
				attr.uri = attr.content;
			} else if (this.view.type == 'email') {
				attr.uri = `mailto://${attr.content}`;
			} else if (this.view.type == 'tel') {
				attr.uri = `tel:${attr.content}`;
			}

			return attr;
		},

		isArray () {
			return Array.isArray(this.attr.content);
		},

		widget () {
			if (!this.attr.content) {
				return 'JmSimple'; // Empty object
			} else if (this.attr.content instanceof Entity) {
				return  'JmEntity';
			} else if (this.attr.content instanceof moment) {
				return 'JmTimestamp';
			} else if (this.attr.content instanceof ModelTableView) {
				return 'JmTagged';
			} else if (tsrx.test(this.attr.content)) {
				return 'JmTimestamp';
			} else if (uuidrx.test(this.attr.content)) {
				return 'JmUuid';
			} else if (this.attr.content instanceof Object) {
				if (this.view.type == 'geo') {
					return 'JmGeo';
				}
				return 'JmObject'; // Other than an Entity
			} else if (this.view.type == 'url') {
				return 'JmLink';
			} else if (this.view.type == 'email') {
				return 'JmLink';
			} else if (this.view.type == 'tel') {
				return 'JmLink';
			} else if (this.view.type == 'time') {
				return 'JmDuration';
			} else if (this.view.type == 'textarea') {
				return 'JmMarkdown';
			} else {
				return 'JmSimple';
			}
		},

		name () {
			return this.attr.name;
		},

		value () {
			return this.attr.content;
		},

		actions () {
			// TODO
			return [];
		}
	},

	methods: {
		key (index) {
			return `${this.name}-${index}`;
		}
	},

	components: {
		...ViewWidgets
	}
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/Cell.vue